import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { DeletionListModule } from '../shared/deletion-list/deletion-list.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { StatusCircleModule } from '../shared/status-circle/status-circle.module';
import { CheckSheetStatusModule } from '../shared/check-sheet-status/check-sheet-status.module';
import { DisciplineStatusCircleModule } from '../shared/discipline-status-circle/discipline-status-circle.module';
import { VendorPillModule } from '../shared/vendor-pill/vendor-pill.module';
import { UserManualDirective } from '../shared/user-manual/user-manual.directive';
import { HeatTraceRoutingModule } from './heat-trace-routing.module';
import { HeatTraceComponent } from './heat-trace.component';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { PipeTestComponent } from '../shared/pipe-test/pipe-test.component';
import { WeekHeaderComponent } from '../shared/week-header/week-header.component';
import { CircuitDiagramComponent } from './circuit-diagram/circuit-diagram.component';
import { CircuitTableComponent } from './circuit-diagram/circuit-table/circuit-table.component';
import { TestDetailsComponent } from './test-details/test-details.component';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { DatePickerModule } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';
import { InsulationComponent } from './insulation/insulation.component';
import { TestHeaderComponent } from './test-header/test-header.component';

@NgModule({
  declarations: [
    HeatTraceComponent,
    PipeTestComponent,
    WeekHeaderComponent,
    CircuitDiagramComponent,
    CircuitTableComponent,
    TestDetailsComponent,
    InsulationComponent,
    TestHeaderComponent,
  ],
  imports: [
    CommonModule,
    HeatTraceRoutingModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatStepperModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatTabsModule,
    MatListModule,
    MatCheckboxModule,
    MatIconModule,
    DeletionListModule,
    MatChipsModule,
    MatDialogModule,
    StatusCircleModule,
    CheckSheetStatusModule,
    DisciplineStatusCircleModule,
    VendorPillModule,
    MatTooltipModule,
    MatSortModule,
    UserManualDirective,
    MatCard,
    MatCardTitle,
    MatCardContent,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    DatePickerModule,
    TableModule,
  ],
})
export class HeatTraceModule {}
